<template>
  <div class="page page__list">
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/document/warehouse/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.wh_description}}</p>
          <p class="list-item-muted">{{item.wh_type}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.wh_code}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.wh_status=='已启用'}"
          >{{item.wh_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}个</label>
    </div>
    <add-button to="/document/warehouse_edit" />
  </div>
</template>

<script>
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/document/warehouse/list",
      params: {
        mode: "MAIN",
        number: 1,
        size: 20
      }
    };
  }
};
</script>